import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { ADD_GROUP_MEMBER, ADD_KEY_TO_GROUP, DELETE_GROUP_MEMBER, GET_GROUP_LIST, GET_GROUP_MEMBERS, GROUP_ACTIVATE, GROUP_CHECK, GROUP_CREATE, GROUP_INFO, GROUP_QUIT, MODIFY_GROUP, REMOVE_GROUP, } from './cgi-path';
var GROUP_SHARE_GROUP_INFO_GET_KEY = false;
var GroupShareRepository = /** @class */ (function () {
    function GroupShareRepository(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
    }
    /**
     * 分享到QQ或者TIM
     */
    GroupShareRepository.prototype.fetchGroupList = function (start, limit) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    start: start,
                    limit: limit,
                    t: (new Date()).getTime(),
                };
                return [2 /*return*/, this.networkRequestService.instance.post(GET_GROUP_LIST, __assign({}, params))];
            });
        });
    };
    /**
     * 查看群组成员
     */
    GroupShareRepository.prototype.fetchGroupMembers = function (groupId, start, limit) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                    start: start,
                    limit: limit,
                    t: (new Date()).getTime(),
                };
                return [2 /*return*/, this.networkRequestService.instance.post(GET_GROUP_MEMBERS, __assign({}, params))];
            });
        });
    };
    /**
     * 修改群组名称
     */
    GroupShareRepository.prototype.modifyGroup = function (groupId, groupName) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                    group_name: groupName,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(MODIFY_GROUP, __assign({}, params))];
            });
        });
    };
    /**
     * 删除群组成员
     */
    GroupShareRepository.prototype.deleteGroupMember = function (groupId, memberTinyId) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                    mem_list: [memberTinyId],
                };
                return [2 /*return*/, this.networkRequestService.instance.post(DELETE_GROUP_MEMBER, __assign({}, params))];
            });
        });
    };
    /**
     * 解散群组
     */
    GroupShareRepository.prototype.removeGroup = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(REMOVE_GROUP, __assign({}, params))];
            });
        });
    };
    /**
     * 添加群组成员
     */
    GroupShareRepository.prototype.addGroupMember = function (groupId, groupMemberList) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                    mem_list: JSON.stringify(groupMemberList),
                };
                return [2 /*return*/, this.networkRequestService.instance.post(ADD_GROUP_MEMBER, __assign({}, params))];
            });
        });
    };
    /**
     * 创建群组
     */
    GroupShareRepository.prototype.createGroup = function (groupName, isTemp) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_name: groupName,
                    is_temp: isTemp,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(GROUP_CREATE, __assign({}, params))];
            });
        });
    };
    /**
     * 单个群组信息
     */
    GroupShareRepository.prototype.fetchGroupInfo = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                    get_key: GROUP_SHARE_GROUP_INFO_GET_KEY,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(GROUP_INFO, __assign({}, params))];
            });
        });
    };
    /**
     * 退出群组
     */
    GroupShareRepository.prototype.quitGroup = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(GROUP_QUIT, __assign({}, params))];
            });
        });
    };
    /**
     * 创建群组状态检测
     */
    GroupShareRepository.prototype.checkCreateGroup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {};
                return [2 /*return*/, this.networkRequestService.instance.post(GROUP_CHECK, __assign({}, params))];
            });
        });
    };
    /**
     * 将群号写入分享key
     */
    GroupShareRepository.prototype.addKeyToGroup = function (groupId, shareKey) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                    share_key: shareKey,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(ADD_KEY_TO_GROUP, __assign({}, params))];
            });
        });
    };
    /**
     * 激活临时群
     */
    GroupShareRepository.prototype.activateGroup = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    group_id: groupId,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(GROUP_ACTIVATE, __assign({}, params))];
            });
        });
    };
    GroupShareRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], GroupShareRepository);
    return GroupShareRepository;
}());
export default GroupShareRepository;
